<script>
	export let issues;

	import PrevApprovedIssue from "./PrevApprovedIssue.svelte";
	import EditForm from "./EditForm.svelte";
	import SplitForm from "./SplitForm.svelte";
	import SuccessPage from "../../../../components/Success/SuccessPage.svelte";
	import { DynamicComponent } from "../../../../store/store";
</script>

<main>
	{#if $DynamicComponent == 1}
		<svelte:component this={PrevApprovedIssue} />
	{:else if $DynamicComponent == 2}
		<svelte:component this={EditForm} {issues} />
	{:else if $DynamicComponent == 3}
		<svelte:component this={SplitForm} {issues} />
	{:else if $DynamicComponent == 4}
		<svelte:component this={SuccessPage} />
	{/if}
</main>
